import { useCallback, useState } from 'react';

/**
 * @param {boolean} defaultValue
 * @returns {[boolean, {setTrue: () => void; setFalse: () => void; toggle: () => void;}]}
 */
export const useBoolean = (defaultValue = false, delay = 0) => {
  const [open, setOpen] = useState(defaultValue);
  const [openDom, setOpenDom] = useState(defaultValue);

  const setTrue = useCallback(() => {
    setOpen(true);
    setTimeout(() => {
      setOpenDom(true);
    }, delay);
  }, [delay]);

  const setFalse = useCallback(() => {
    setOpenDom(false);
    setTimeout(
      () => {
        setOpen(false);
      },
      delay > 300 ? 300 : delay
    );
  }, [delay]);

  const toggle = useCallback(() => {
    setOpen((state) => !state);
  }, []);

  return [open, { setTrue, setFalse, toggle }, openDom];
};
